/* =========================================================================
   TT_FULL_FRONT_START
   Adds a "Left Chest / Full Front" mode toggle to the V2 mockup preview.

   TWO SEPARATE FLAGS. Do not merge them again.

     clientFrontOnly  This shop prints FRONT ONLY. Hides Rear and Sleeve
                      views. Applies to EVERY item the shop orders,
                      pocket tees and zip hoodies included.

     fullFrontOnly    Use the big full front artwork instead of the left
                      chest logo. Only set when the garment is on the
                      FullFront-OK allowlist.

     garmentAllowed   Product carries the FullFront-OK tag.

   A pocket tee at a front-only shop = no Rear, no Sleeve, left chest
   logo, and no Full Front button anywhere.

   ARCHITECTURE:
     Client settings live on the CLIENT PROFILE collection, never on the
     product, because products are shared across every client.

       mock.logo_front_full     Image — this shop's full front artwork
       mock.full_front_handles  List  — product handles that are front-only
       mock.full_front_only     Bool  — front-only for the whole account

     The Full Front toggle only renders when the client has artwork on
     file AND the garment is on the allowlist.

   WHEN FULL FRONT IS ACTIVE (front view only):
     * full front artwork renders
     * chest logo is hidden
     * employee name overlay is hidden
     * back and sleeve views are never touched

   Placement (optional) — product mock.placement_json:
     "front": { "logo_front_full": { "x":50, "y":30, "w":42, "h":32 } }

   This file is ADDITIVE. It does not modify
   sections/tt-mockup-preview-v2.liquid. Delete the TT Full Front section
   from templates/page.tt-mockup-preview-v2.json to fully disable.

   ---- DEV BUILD 2026-08-28 : TWO CHANGES ONLY -------------------------
   1. TT_FF_GARMENT_HOST   the artwork box is appended to #ttV2Garment
                           (the garment rectangle) instead of #ttV2Root
                           (the grey stage), when the frame module is
                           present. Falls back to root if it is not.
   2. TT_FF_TRANSLATE      placement values — INCLUDING DEFAULT_BOX — are
                           routed through TTGarmentFrame.translate() so the
                           legacy stage-relative numbers keep their current
                           physical meaning inside the new frame.

   DEFAULT_BOX ITSELF IS UNCHANGED. Only the frame it is interpreted
   against has changed, which is precisely why it must be translated too.
   ---------------------------------------------------------------------
   ========================================================================= */
(function () {
  'use strict';

  if (window.__TT_FULL_FRONT_BOUND__) return;
  window.__TT_FULL_FRONT_BOUND__ = true;

  /* --- defaults used when placement_json has no logo_front_full entry --- */
  var DEFAULT_BOX = { x: 50, y: 30, w: 42, h: 32, anchor: 'center' };

  var mode = 'chest';          /* 'chest' | 'full' */
  var cfg = {
    client: '',
    handle: '',
    artwork: '',
    fullFrontOnly: false,
    clientFrontOnly: false,
    garmentAllowed: false
  };

  var root, chestBox, nameBox, toggleEl, ffBox, ffImg, emptyEl;

  /* ---------------------------------------------------------------- utils */
  function readJsonScript(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try {
      var raw = (el.textContent || '').trim();
      if (!raw) return fallback;
      var parsed = JSON.parse(raw);
      if (typeof parsed === 'string') parsed = JSON.parse(parsed);
      return parsed;
    } catch (e) {
      return fallback;
    }
  }

  function param(key) {
    try {
      return new URL(window.location.href).searchParams.get(key) || '';
    } catch (e) {
      return '';
    }
  }

  function currentView() {
    var active = document.querySelector('[data-tt-v2-view].is-active');
    return active ? active.getAttribute('data-tt-v2-view') : 'front';
  }

  /* ------------------------------------------------- TT_FF_BUILD_TOGGLE */
  function buildToggle(card) {
    var wrap = document.createElement('div');
    wrap.id = 'ttFfToggle';
    wrap.className = 'tt-ff-toggle';
    wrap.style.cssText =
      'display:none;align-items:center;gap:10px;flex-wrap:wrap;margin:0 0 14px;';

    var label = document.createElement('span');
    label.textContent = 'Print:';
    label.style.cssText = 'font-size:13px;font-weight:600;color:#666;';

    var chestBtn = document.createElement('button');
    chestBtn.type = 'button';
    chestBtn.className = 'tt-v2-pill is-active';
    chestBtn.setAttribute('data-tt-ff-mode', 'chest');
    chestBtn.textContent = 'Left Chest';

    var fullBtn = document.createElement('button');
    fullBtn.type = 'button';
    fullBtn.className = 'tt-v2-pill';
    fullBtn.setAttribute('data-tt-ff-mode', 'full');
    fullBtn.textContent = 'Full Front';

    wrap.appendChild(label);
    wrap.appendChild(chestBtn);
    wrap.appendChild(fullBtn);

    card.insertBefore(wrap, card.firstChild);
    return wrap;
  }

  /* ---------------------------------------------- TT_FF_BUILD_ARTWORK_BOX */
  function buildArtworkBox() {
    if (!cfg.artwork) return null;

    var box = document.createElement('div');
    box.id = 'ttV2LogoBoxFullFront';
    box.className = 'tt-v2-logo-box tt-v2-logo-box--fullfront';
    box.style.display = 'none';

    ffImg = document.createElement('img');
    ffImg.className = 'tt-v2-logo';
    ffImg.src = cfg.artwork;
    ffImg.alt = 'Full front artwork';
    ffImg.setAttribute('loading', 'eager');
    ffImg.width = 1600;
    ffImg.height = 1600;

    box.appendChild(ffImg);

    /* TT_FF_GARMENT_HOST — anchor to the garment, not the stage.
       On a cold load the frame has not activated yet and this falls back to
       the stage; TT_FF_REPARENT in applyPlacement() corrects that later. */
    var host =
      (window.TTGarmentFrame && window.TTGarmentFrame.host && window.TTGarmentFrame.host()) ||
      document.getElementById('ttV2Garment') ||
      root;

    host.appendChild(box);
    return box;
  }

  /* ----------------------------------------------- TT_FF_BUILD_EMPTY_STATE */
  function buildEmptyState(card) {
    var handle = cfg.handle || param('tt_handle');
    var client = cfg.client || param('client');

    var href =
      '/pages/mockup-request?client=' + encodeURIComponent(client) +
      '&handle=' + encodeURIComponent(handle) +
      '&tt_view=front&missing=front_artwork';

    var box = document.createElement('div');
    box.id = 'ttFfEmpty';
    box.className = 'tt-v2-empty';
    box.style.cssText = 'display:none;margin-top:14px;';

    var msg = document.createElement('p');
    msg.textContent = 'Full front artwork is not on file for this shop yet.';

    var sub = document.createElement('p');
    sub.className = 'tt-v2-empty-sub';

    var cta = document.createElement('a');
    cta.className = 'tt-btn tt-btn--orange';
    cta.href = href;
    cta.textContent = 'Request a Mockup';

    sub.appendChild(cta);
    box.appendChild(msg);
    box.appendChild(sub);
    card.appendChild(box);
    return box;
  }

  /* Shared writer. Identical style output for both the V2 and legacy paths. */
  function writeBox(c) {
    ffBox.style.left = c.x + '%';
    ffBox.style.top = c.y + '%';
    ffBox.style.width = c.w + '%';
    ffBox.style.height = c.h + '%';

    if (c.anchor === 'none') {
      ffBox.style.transform = 'none';
    } else if (c.anchor === 'top') {
      ffBox.style.transform = 'translate(-50%, 0)';
    } else {
      ffBox.style.transform = 'translateX(-50%)';
    }
  }

  /* -------------------------------------------------- TT_FF_APPLY_PLACEMENT */
  function applyPlacement() {
    if (!ffBox) return;

    /* ---- TT_FF_REPARENT — COLD-LOAD SAFETY ------------------------------
       Both scripts are deferred, so document.readyState is 'interactive' and
       both init() functions run immediately. On an UNCACHED load the base
       image is not yet complete, so the garment frame has not activated and
       TTGarmentFrame.host() returned null when the box was built - leaving it
       on #ttV2Root, the grey stage. The frame's build() only relocates the
       four Liquid-rendered overlays (chest / back / sleeve / name), so the
       Full Front box would stay on the stage permanently and its
       garment-relative V2 percentages would resolve against the wrong box.

       Re-home it here instead, on every apply, as soon as the host exists.
       Cheap, idempotent, and it touches nothing in tt-garment-frame.js. */
    var ffHost = (window.TTGarmentFrame && typeof window.TTGarmentFrame.host === 'function')
      ? window.TTGarmentFrame.host()
      : null;

    if (ffHost && ffBox.parentNode !== ffHost) {
      ffHost.appendChild(ffBox);
    }
    /* ---- TT_FF_REPARENT_END --------------------------------------------- */

    /* ---- TT_FF_V2_DIRECT_START — CALIBRATED GARMENTS ONLY ----------------
       Same calibration fact as the base gate and the renderer: a garment
       block in mock.placement_json_v2. When the garment is calibrated AND
       carries front.logo_front_full, that box is ALREADY garment-relative,
       so it is applied RAW. Passing it through TTGarmentFrame.translate()
       would corrupt it -- translate() converts legacy stage coordinates
       INTO this frame, and these are already in it.

       Legacy garments never reach this branch and fall through to the
       unchanged v1 -> DEFAULT_BOX -> translate() path below.

       tt-v2-ff-ok is what reveals the box under the strict CSS. It is
       granted ONLY here, so a calibrated garment can never show a
       translated default on a V2 canvas, and Full Front no longer depends
       on a chest overlay existing. */
    var ffV2 = readJsonScript('TT_V2_RENDER_CFG', null);
    var saved = ffV2 && ffV2.saved;

    if (saved && typeof saved === 'object' && saved.garment &&
        saved.front && saved.front.logo_front_full) {
      var z = saved.front.logo_front_full;

      if (typeof z.x !== 'undefined' && typeof z.y !== 'undefined' &&
          typeof z.w !== 'undefined' && typeof z.h !== 'undefined') {
        writeBox({
          x: z.x,
          y: z.y,
          w: z.w,
          h: z.h,
          anchor: z.anchor || 'center'
        });

        var wrapV2 = document.querySelector('.tt-v2-wrap');
        if (wrapV2) wrapV2.classList.add('tt-v2-ff-ok');
        return;
      }
    }
    /* ---- TT_FF_V2_DIRECT_END ------------------------------------------- */

    var placement = readJsonScript('TT_PLACEMENT_JSON_V2', null);
    var c = DEFAULT_BOX;

    if (placement && placement.front && placement.front.logo_front_full) {
      var raw = placement.front.logo_front_full;
      c = {
        x: typeof raw.x !== 'undefined' ? raw.x : DEFAULT_BOX.x,
        y: typeof raw.y !== 'undefined' ? raw.y : DEFAULT_BOX.y,
        w: typeof raw.w !== 'undefined' ? raw.w : DEFAULT_BOX.w,
        h: typeof raw.h !== 'undefined' ? raw.h : DEFAULT_BOX.h,
        anchor: raw.anchor || DEFAULT_BOX.anchor
      };
    }

    /* TT_FF_TRANSLATE — legacy stage-relative -> garment-relative.
       Applies to DEFAULT_BOX too: the constant is untouched, but the frame
       it describes has changed, so it must go through the same transform. */
    if (window.TTGarmentFrame && typeof window.TTGarmentFrame.translate === 'function') {
      c = window.TTGarmentFrame.translate(c, 'front');
    }

    writeBox(c);
  }

  /* --------------------------------------------- TT_FF_FRONT_ONLY_LOCKDOWN */
  function applyFrontOnlyLockdown() {
    /* Rear and Sleeve are hidden by the CLIENT rule, on every garment they
       order — pocket tees and zip hoodies included. Not gated by allowlist. */
    if (cfg.clientFrontOnly) {
      ['back', 'sleeve'].forEach(function (v) {
        var pill = document.querySelector('[data-tt-v2-view="' + v + '"]');
        if (pill) pill.style.display = 'none';
      });

      /* If Rear or Sleeve happens to be the active view, snap to Front. */
      var active = document.querySelector('[data-tt-v2-view].is-active');
      var activeName = active ? active.getAttribute('data-tt-v2-view') : '';
      if (activeName === 'back' || activeName === 'sleeve') {
        var frontPill = document.querySelector('[data-tt-v2-view="front"]');
        if (frontPill) frontPill.click();
      }
    }

    /* Full Front forced: hide the Left Chest option. Allowlisted only. */
    if (cfg.fullFrontOnly) {
      mode = 'full';
      var chestBtn = document.querySelector('[data-tt-ff-mode="chest"]');
      if (chestBtn) chestBtn.style.display = 'none';
    }
  }

  /* ------------------------------------------------------ TT_FF_APPLY_MODE */
  function apply() {
    if (cfg.fullFrontOnly) mode = 'full';

    var isFront = currentView() === 'front';

    if (toggleEl) toggleEl.style.display = isFront ? 'flex' : 'none';

    /* Not front view, or chest mode: hand control back to the section script */
    if (!isFront || mode === 'chest') {
      if (ffBox) ffBox.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'none';
      return;
    }

    /* Full Front mode on the front view */
    if (chestBox) {
      chestBox.style.display = 'none';
      chestBox.setAttribute('aria-hidden', 'true');
    }

    if (nameBox) {
      nameBox.hidden = true;
      nameBox.style.display = 'none';
      nameBox.setAttribute('aria-hidden', 'true');
    }

    if (cfg.artwork && ffBox) {
      applyPlacement();
      ffBox.style.display = 'flex';
      ffBox.setAttribute('aria-hidden', 'false');
      if (emptyEl) emptyEl.style.display = 'none';
    } else {
      if (ffBox) ffBox.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'block';
    }
  }

  function syncToggleUI() {
    var btns = document.querySelectorAll('[data-tt-ff-mode]');
    Array.prototype.forEach.call(btns, function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-tt-ff-mode') === mode);
    });
  }

  /* -------------------------------------------------------------- TT_FF_INIT */
  function init() {
    root = document.getElementById('ttV2Root');
    if (!root) return;

    var card = root.parentElement;
    if (!card) return;

    cfg = readJsonScript('TT_FULL_FRONT_JSON', cfg) || cfg;

    /* ---------------------------------------- TT_FF_VISIBILITY_GATE_START
       Nothing to do at all? Build nothing and leave the page as it was.
       Note clientFrontOnly still needs us even with no artwork, because
       it is what hides the Rear and Sleeve pills. */
    if (!cfg.artwork && !cfg.fullFrontOnly && !cfg.clientFrontOnly) return;
    /* ---------------------------------------- TT_FF_VISIBILITY_GATE_END */

    chestBox = document.getElementById('ttV2LogoBoxChest');
    nameBox = document.getElementById('ttV2NameBox');

    /* Toggle only exists where the garment can actually take a full front. */
    if (cfg.garmentAllowed && cfg.artwork) {
      toggleEl = buildToggle(card);
      ffBox = buildArtworkBox();
    }

    /* Empty state only when full front is expected but art is missing. */
    if (cfg.garmentAllowed && !cfg.artwork && cfg.clientFrontOnly) {
      emptyEl = buildEmptyState(card);
    }

    applyFrontOnlyLockdown();

    document.addEventListener('click', function (e) {
      var modeBtn = e.target.closest && e.target.closest('[data-tt-ff-mode]');
      if (modeBtn) {
        e.preventDefault();
        if (cfg.fullFrontOnly) return;

        mode = modeBtn.getAttribute('data-tt-ff-mode') || 'chest';
        syncToggleUI();

        /* Returning to chest mode: let the section script restore its own
           chest logo and name state, then re-apply ours. */
        if (mode === 'chest') {
          var activePill = document.querySelector('[data-tt-v2-view].is-active');
          if (activePill) activePill.click();
        }

        setTimeout(apply, 0);
        return;
      }

      var viewBtn = e.target.closest && e.target.closest('[data-tt-v2-view]');
      if (viewBtn) setTimeout(apply, 0);
    });

    syncToggleUI();
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
/* === TT_FULL_FRONT_END === */
